// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N0, N40, N50, N500, R400 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var UserContainer = styled.span({
  display: 'inline-flex',
  alignItems: 'baseline',
  paddingLeft: "var(--ds-space-025, 2px)",
  borderRadius: '10px',
  cursor: 'pointer',
  userSelect: 'none'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref) {
  var selected = _ref.selected,
    error = _ref.error;
  if (selected) {
    if (error) {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      return css({
        color: "var(--ds-text-inverse, ".concat(N0, ")"),
        backgroundColor: "var(--ds-background-danger-bold, ".concat(R400, ")"),
        textDecoration: 'wavy underline',
        textDecorationThickness: '1px',
        textDecorationSkipInk: 'none',
        textDecorationColor: "var(--ds-text-inverse, ".concat(N0, ")")
      });
    } else {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      return css({
        color: "var(--ds-text, ".concat(N0, ")"),
        backgroundColor: "var(--ds-background-selected, ".concat(N500, ")"),
        boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, transparent)")
      });
    }
  } else {
    if (error) {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      return css({
        color: "var(--ds-text-subtle, ".concat(N500, ")"),
        backgroundColor: "var(--ds-background-neutral, ".concat(N40, ")"),
        textDecoration: 'wavy underline',
        textDecorationThickness: '1px',
        textDecorationSkipInk: 'none',
        textDecorationColor: "var(--ds-text-danger, ".concat(R400, ")"),
        '&:hover': {
          backgroundColor: "var(--ds-background-neutral-hovered, ".concat(N50, ")")
        }
      });
    } else {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      return css({
        color: "var(--ds-text-subtle, ".concat(N500, ")"),
        backgroundColor: "var(--ds-background-neutral, ".concat(N40, ")"),
        '&:hover': {
          backgroundColor: "var(--ds-background-neutral-hovered, ".concat(N50, ")")
        }
      });
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NameContainer = styled.span({
  marginLeft: "var(--ds-space-075, 6px)",
  marginRight: "var(--ds-space-100, 8px)",
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: "var(--ds-space-250, 20px)"
});

/* Override Avatar styles to match design spec */
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AvatarWrapper = styled.div({
  height: "var(--ds-space-200, 16px)",
  width: "var(--ds-space-200, 16px)",
  alignSelf: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> div span': {
    margin: "var(--ds-space-0, 0px)"
  }
});